import React from 'react';
import styled from 'styled-components';

import Imgix from 'shared/components/imgix';
import { ImgixDefaultSettings } from 'shared/constants';
import { Product } from 'src/dispensary-admin/components/product-card/product-card.types';
import { useProductCard } from 'src/dispensary-admin/components/product-card/use-product-card';

const GRID_IMGIX_PARAMS = {
  ...ImgixDefaultSettings,
  h: 120,
  w: 120,
  fit: 'max',
};

type ProductGridCardProps = {
  product: Product;
};

/** Renders a compact image-only product card for mobile app grid sections. */
export function ProductGridCard({ product }: ProductGridCardProps): JSX.Element {
  const { imageUrl } = useProductCard(product);

  return (
    <Card data-testid='product-grid-card'>
      <Image src={imageUrl} imgixParams={GRID_IMGIX_PARAMS} />
    </Card>
  );
}

const Card = styled.div`
  aspect-ratio: 1 / 1;
  background: #fff;
  border-radius: ${({ theme }) => theme?.radius?.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

const Image = styled(Imgix)<{ src: string; imgixParams: Record<string, number | string> }>`
  display: block;
  margin: 0 auto;
  max-height: 100%;
  max-width: 100%;
`;
